import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderFilter, Logic } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapProfilingCodeOptions } from '../lib/mapProfilingCodeOptions'
import { ProfilingCodeType } from '../model/types'

export const fetchProfilingCodeOptions = (
  types: ProfilingCodeType[] = [],
  options?: ICrudFetchOptions
) => {
  const source = CrudStore.get(
    CrudStoreItem.CodesDictionary,
    options?.cacheKey ?? 'ProfilingCodeOptions'
  )

  const filter: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      options?.filters,
      {
        logic: Logic.OR,
        filters: types.map((type) => ({ field: 'type', operator: 'contains', value: type })),
      },
    ].filter(Boolean) as IDataProviderFilter[],
  }

  return source
    .fetch({
      force: options?.isForce,
      paging: options?.paging,
      skipHierarchyFilter: options?.skipHierarchyFilter,
      skipTotal: options?.skipTotal,
      sort: options?.sort,
      filter,
    })
    .then((data) => mapProfilingCodeOptions(data?.items || []))
    .catch((error) => {
      Logger.error('Error fetching profiling code options:', error)
      throw error
    })
}
